import * as React from "react";
import { ItemProps } from "./";
import GroupSelectorItem from "./GroupSelectorItem";

export function hasItemsSelected(items?: any[]) {
  if (!items) {
    return false;
  }
  return items.some(item => item.selected);
}

type GroupSelectorItemsProps = {
  items: ItemProps[];
  onChange: (id: ItemProps["id"], selected: ItemProps["selected"]) => void;
  level?: number;
  parentSelected?: boolean;
  showOnlySelected?: boolean;
};

function GroupSelectorItems({
  items,
  onChange,
  level,
  parentSelected,
  showOnlySelected
}: GroupSelectorItemsProps) {
  level = !level ? 1 : level + 1;

  return (
    <div>
      {items.map((item: ItemProps) => {
        const { title, id, selected, open } = item;

        const isVisible = showOnlySelected
          ? selected ||
            parentSelected ||
            (item.items && hasItemsSelected(item.items))
          : true;

        return (
          isVisible && (
            <GroupSelectorItem
              key={id}
              title={title}
              id={id}
              parentSelected={parentSelected}
              selected={selected}
              items={item.items}
              open={open}
              level={level}
              onChange={onChange}
              showOnlySelected={showOnlySelected}
            />
          )
        );
      })}
    </div>
  );
}

export default GroupSelectorItems;
